/**
 * @generated SignedSource<<74f226efdc48d81060c2d5d503d5b544>>
 * @relayHash 069d015061bcfd571be3a20405867090
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 069d015061bcfd571be3a20405867090

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ccnId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortTitle",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "CcnFromComStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scope",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "offerType",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "idcc",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ManageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CcnFromCom",
        "kind": "LinkedField",
        "name": "ccnsFromCom",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ManageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CcnFromCom",
        "kind": "LinkedField",
        "name": "ccnsFromCom",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "069d015061bcfd571be3a20405867090",
    "metadata": {},
    "name": "ManageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "26ba8b2b2ec236dac86725db3ed6f1fa";

export default node;
